const emailDomains = [
    "yahoo.com",
    "hotmail.com",
    "gmail.com",
    "me.com",
    "aol.com",
    "mac.com",
    "live.com",
    "googlemail.com",
    "msn.com",
    "facebook.com",
    "verizon.net",
    "outlook.com",
    "icloud.com",
    "table.co",
    "fb.com",
];

export default emailDomains;
